import React from 'react'
import s from './LoaderProgressBar.module.css'

const LoaderProgressBar = () => {
  return (
    <div className={s.demoContainer}>
      <div className={s.progressBar}>
        <div className={s.progressBarValue}></div>
      </div>
    </div>
  )
}

export default LoaderProgressBar
